// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { OrderFiltersDto, OrderFiltersDtoFormGroup } from './OrderFiltersDto';

export class CollectOrderFiltersDto extends OrderFiltersDto {
}

export interface CollectOrderFiltersDtoFormGroup extends OrderFiltersDtoFormGroup {
}
